var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-tabs",
        {
          attrs: { color: "transparent", "show-arrows": "" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("v-tabs-slider", { attrs: { color: "primary" } }),
          _vm._v(" "),
          _vm.isTenant
            ? _c(
                "v-flex",
                _vm._l(_vm.tabs, function(tabItem) {
                  return _c("v-tab", { key: tabItem }, [
                    _vm._v("\n        " + _vm._s(tabItem) + "\n      ")
                  ])
                }),
                1
              )
            : _c(
                "v-flex",
                _vm._l(_vm.warehouseTabs, function(tabItem) {
                  return _c("v-tab", { key: tabItem }, [
                    _vm._v("\n        " + _vm._s(tabItem) + "\n      ")
                  ])
                }),
                1
              ),
          _vm._v(" "),
          _c(
            "v-tabs-items",
            {
              attrs: { touchless: "" },
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            _vm._l(6, function(item, index) {
              return _c("v-tab-item", { key: "item" + index }, [
                _vm.tab === 0 && index === 0
                  ? _c(
                      "div",
                      [
                        _c("PaginationController", {
                          attrs: {
                            getDataActionName: "getActiveForecasts",
                            haveStartDate: "",
                            haveSearchBox: "",
                            keepKeywordCase: "",
                            select: _vm.selectedValue,
                            startDateLabel: _vm.$t("processStartDate"),
                            searchBoxLabel:
                              _vm.$t("tracking") +
                              " / " +
                              _vm.$t("upc") +
                              " / sku / " +
                              _vm.$t("boxMark"),
                            historyLimit: _vm.historyLimit
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "beforeSearchBox",
                                fn: function() {
                                  return [
                                    _vm.isWarehouse
                                      ? _c(
                                          "v-flex",
                                          { attrs: { md4: "" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                items:
                                                  _vm.organizationSelections,
                                                label: _vm.$t(
                                                  "selectOrganization"
                                                ),
                                                "item-text": "displayName",
                                                "item-value": "key"
                                              },
                                              model: {
                                                value: _vm.selectedValue,
                                                callback: function($$v) {
                                                  _vm.selectedValue = $$v
                                                },
                                                expression: "selectedValue"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _c(
                                          "v-flex",
                                          { attrs: { md4: "" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                items: [
                                                  {
                                                    displayName:
                                                      "-- " +
                                                      _vm.$t("all") +
                                                      " --",
                                                    key: ""
                                                  },
                                                  {
                                                    displayName: _vm.$t(
                                                      "ready"
                                                    ),
                                                    key: "ready"
                                                  },
                                                  {
                                                    displayName: _vm.$t(
                                                      "partial"
                                                    ),
                                                    key: "partial"
                                                  }
                                                ],
                                                label: _vm.$t("selectStatus"),
                                                "item-text": "displayName",
                                                "item-value": "key"
                                              },
                                              model: {
                                                value: _vm.selectedValue,
                                                callback: function($$v) {
                                                  _vm.selectedValue = $$v
                                                },
                                                expression: "selectedValue"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "beforeMenu",
                                fn: function() {
                                  return [
                                    _vm.isTenant
                                      ? _c(
                                          "v-flex",
                                          {
                                            staticClass: "headline",
                                            attrs: { md1: "" }
                                          },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "primary",
                                                  disabled:
                                                    !_vm
                                                      .openForecastedWarehouseKey
                                                      .length &&
                                                    !!_vm.tenantInfo
                                                      .closePKGModeTime
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.addNewForecast()
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { dark: "" } },
                                                  [_vm._v("add")]
                                                ),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.$t("forecast"))
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "dataTable",
                                fn: function() {
                                  return [
                                    _c("v-data-table", {
                                      attrs: {
                                        "item-key": "_key",
                                        expand: "",
                                        headers: _vm.headers,
                                        items: _vm.forecasts,
                                        "hide-actions": ""
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "headerCell",
                                            fn: function(props) {
                                              return [
                                                props.header.text === "quantity"
                                                  ? [
                                                      _c("v-flex", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("forecast")
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("v-flex", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "inboundQuantity"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  : props.header.text === "time"
                                                  ? [
                                                      _c("v-flex", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("createTime")
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("v-flex", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "lastModifiedTime"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  : [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.header.text
                                                        )
                                                      )
                                                    ]
                                              ]
                                            }
                                          },
                                          {
                                            key: "items",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "tr",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        props.expanded = !props.expanded
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-center"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.index + 1
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.item._key
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            style: props.item
                                                              .isDisabledOrg
                                                              ? "background-color: yellow"
                                                              : ""
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm.isTenant
                                                                    ? "" +
                                                                        _vm.getWarehouseName(
                                                                          props
                                                                            .item
                                                                            .warehouseKey
                                                                        )
                                                                    : "" +
                                                                        _vm.getOrganizationName(
                                                                          props
                                                                            .item
                                                                            .organizationKey,
                                                                          props.item
                                                                        )
                                                                ) +
                                                                "\n                      "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("div", [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.getWarehouseSiteName(
                                                                  props.item
                                                                    .warehouseKey,
                                                                  props.item
                                                                    .warehouseSite
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.calculateTotalQty(
                                                                props.item
                                                                  .pkgItems
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.calculateSkuOfNum(
                                                                props.item
                                                                  .pkgItems
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.calculateBoxQty(
                                                                props.item
                                                                  .pkgItems
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                props.item
                                                                  .status ===
                                                                  "ready"
                                                                  ? "readyLower"
                                                                  : props.item
                                                                      .status
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              props.item
                                                                .shipType ||
                                                                "N/A"
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.toDateYYYYMMDD(
                                                              props.item
                                                                .createTime
                                                            )
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.toDateYYYYMMDD(
                                                              props.item
                                                                .lastModifiedTime
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticStyle: {
                                                          "white-space":
                                                            "pre-line",
                                                          "word-break":
                                                            "break-word",
                                                          "max-width": "300px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              props.item.note
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    !_vm.isWarehouse
                                                      ? _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-center"
                                                          },
                                                          [
                                                            _c(
                                                              "v-menu",
                                                              {
                                                                attrs: {
                                                                  "offset-y": ""
                                                                },
                                                                scopedSlots: _vm._u(
                                                                  [
                                                                    {
                                                                      key:
                                                                        "activator",
                                                                      fn: function(
                                                                        ref
                                                                      ) {
                                                                        var on =
                                                                          ref.on
                                                                        return [
                                                                          _c(
                                                                            "v-tooltip",
                                                                            {
                                                                              attrs: {
                                                                                top:
                                                                                  ""
                                                                              },
                                                                              scopedSlots: _vm._u(
                                                                                [
                                                                                  {
                                                                                    key:
                                                                                      "activator",
                                                                                    fn: function(
                                                                                      tooltip
                                                                                    ) {
                                                                                      return [
                                                                                        _c(
                                                                                          "div",
                                                                                          _vm._g(
                                                                                            {},
                                                                                            tooltip.on
                                                                                          ),
                                                                                          [
                                                                                            _c(
                                                                                              "v-btn",
                                                                                              {
                                                                                                attrs: {
                                                                                                  dark:
                                                                                                    "",
                                                                                                  icon:
                                                                                                    "",
                                                                                                  flat:
                                                                                                    "",
                                                                                                  color:
                                                                                                    "primary"
                                                                                                },
                                                                                                on: {
                                                                                                  click: function(
                                                                                                    $event
                                                                                                  ) {
                                                                                                    $event.stopPropagation()
                                                                                                    return on.click.apply(
                                                                                                      null,
                                                                                                      arguments
                                                                                                    )
                                                                                                  }
                                                                                                }
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "v-icon",
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "build"
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              ],
                                                                                              1
                                                                                            )
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      ]
                                                                                    }
                                                                                  }
                                                                                ],
                                                                                null,
                                                                                true
                                                                              )
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                            " +
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "more"
                                                                                    )
                                                                                  ) +
                                                                                  "\n                          "
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      }
                                                                    }
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                                model: {
                                                                  value:
                                                                    _vm.menu[
                                                                      String(
                                                                        props.item._key.slice(
                                                                          -5
                                                                        )
                                                                      )
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.menu,
                                                                      String(
                                                                        props.item._key.slice(
                                                                          -5
                                                                        )
                                                                      ),
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "menu[String(props.item._key.slice(-5))]"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-list",
                                                                  [
                                                                    _c(
                                                                      "v-list-tile",
                                                                      [
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs: {
                                                                              flat:
                                                                                "",
                                                                              color:
                                                                                "primary"
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.showDetailDialog(
                                                                                  props.item
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                              " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "open"
                                                                                  )
                                                                                ) +
                                                                                "\n                            "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "v-list-tile",
                                                                      [
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs: {
                                                                              flat:
                                                                                "",
                                                                              loading:
                                                                                props
                                                                                  .item
                                                                                  .isLoading,
                                                                              disabled:
                                                                                props
                                                                                  .item
                                                                                  .status ===
                                                                                "ready",
                                                                              color:
                                                                                "primary"
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.confirmForecast(
                                                                                  props.item
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                              " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "confirm"
                                                                                  )
                                                                                ) +
                                                                                "\n                            "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "v-list-tile",
                                                                      [
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs: {
                                                                              flat:
                                                                                "",
                                                                              loading:
                                                                                props
                                                                                  .item
                                                                                  .isPrinting,
                                                                              disabled:
                                                                                props
                                                                                  .item
                                                                                  .isPrinting ||
                                                                                !props
                                                                                  .item
                                                                                  .isDClass,
                                                                              color:
                                                                                "primary"
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.printBoxMarks(
                                                                                  props.item
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                              " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "printBoxMark"
                                                                                  )
                                                                                ) +
                                                                                "\n                            "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "v-list-tile",
                                                                      [
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs: {
                                                                              flat:
                                                                                "",
                                                                              disabled:
                                                                                props
                                                                                  .item
                                                                                  .status ===
                                                                                "partial",
                                                                              loading:
                                                                                props
                                                                                  .item
                                                                                  .isDelLoading,
                                                                              color:
                                                                                "primary"
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.deleteForecast(
                                                                                  props.item
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                              " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "delete"
                                                                                  )
                                                                                ) +
                                                                                "\n                            "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.isWarehouse
                                                      ? _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-center"
                                                          },
                                                          [
                                                            _c(
                                                              "v-layout",
                                                              {
                                                                attrs: {
                                                                  "justify-space-between":
                                                                    "",
                                                                  row: ""
                                                                }
                                                              },
                                                              [
                                                                props.item
                                                                  .status ===
                                                                "partial"
                                                                  ? _c(
                                                                      "v-btn",
                                                                      {
                                                                        attrs: {
                                                                          flat:
                                                                            "",
                                                                          loading:
                                                                            props
                                                                              .item
                                                                              .isLoading,
                                                                          disabled: !_vm.isWarehouseOwner,
                                                                          color:
                                                                            "primary"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                            return _vm.confirmForecast(
                                                                              props.item
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                              " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "confirm"
                                                                              )
                                                                            ) +
                                                                            "\n                        "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "v-btn",
                                                                      {
                                                                        attrs: {
                                                                          loading:
                                                                            props
                                                                              .item
                                                                              .isLoading,
                                                                          disabled: !(
                                                                            _vm.isWarehouseOwner &&
                                                                            props
                                                                              .item
                                                                              .isDisabledOrg
                                                                          ),
                                                                          flat:
                                                                            "",
                                                                          color:
                                                                            "primary"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                            return _vm.deleteForecast(
                                                                              props.item
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                            " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "delete"
                                                                              )
                                                                            ) +
                                                                            "\n                        "
                                                                        )
                                                                      ]
                                                                    )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            }
                                          },
                                          {
                                            key: "expand",
                                            fn: function(props) {
                                              return [
                                                _c("ForecastTableExpand", {
                                                  attrs: { item: props.item }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: _vm.forecasts,
                            callback: function($$v) {
                              _vm.forecasts = $$v
                            },
                            expression: "forecasts"
                          }
                        }),
                        _vm._v(" "),
                        !!_vm.featureInboundForecastDropshipping.length
                          ? [
                              _vm.isShowForecastDialog
                                ? _c("DropshippingForecastPopup", {
                                    attrs: {
                                      isAddForecast: _vm.isAddForecast,
                                      forecast: _vm.forecast
                                    },
                                    on: {
                                      close: _vm.closeForecastDialog,
                                      addForecast: _vm.addForecast,
                                      updateForecast: _vm.updateForecast
                                    },
                                    model: {
                                      value: _vm.isShowForecastDialog,
                                      callback: function($$v) {
                                        _vm.isShowForecastDialog = $$v
                                      },
                                      expression: "isShowForecastDialog"
                                    }
                                  })
                                : _vm._e()
                            ]
                          : [
                              _vm.isShowForecastDialog
                                ? _c("ForecastDetailPopup", {
                                    attrs: {
                                      isAddForecast: _vm.isAddForecast,
                                      forecast: _vm.forecast
                                    },
                                    on: {
                                      close: _vm.closeForecastDialog,
                                      addForecast: _vm.addForecast,
                                      updateForecast: _vm.updateForecast
                                    },
                                    model: {
                                      value: _vm.isShowForecastDialog,
                                      callback: function($$v) {
                                        _vm.isShowForecastDialog = $$v
                                      },
                                      expression: "isShowForecastDialog"
                                    }
                                  })
                                : _vm._e()
                            ]
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.tab === 1 && index === 1
                  ? _c(
                      "div",
                      [
                        _c("PaginationController", {
                          attrs: {
                            getDataActionName: "getHistoryForecasts",
                            haveStartDate: "",
                            haveSearchBox: "",
                            keepKeywordCase: "",
                            select: _vm.selectedStatus,
                            startDateLabel: _vm.$t("processStartDate"),
                            isRefreshSelect: false,
                            searchBoxLabel:
                              _vm.$t("tracking") +
                              " / " +
                              _vm.$t("upc") +
                              " / sku / " +
                              _vm.$t("boxMark"),
                            historyLimit: _vm.historyLimit
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "beforeSearchBox",
                                fn: function() {
                                  return [
                                    _c(
                                      "v-flex",
                                      { attrs: { md4: "" } },
                                      [
                                        _c("v-autocomplete", {
                                          attrs: {
                                            items: [
                                              {
                                                displayName:
                                                  "-- " + _vm.$t("all") + " --",
                                                key: ""
                                              },
                                              {
                                                displayName: _vm.$t("done"),
                                                key: "done"
                                              },
                                              {
                                                displayName: _vm.$t(
                                                  "confirmed"
                                                ),
                                                key: "confirmed"
                                              }
                                            ],
                                            label: _vm.$t("selectStatus"),
                                            "item-text": "displayName",
                                            "item-value": "key"
                                          },
                                          model: {
                                            value: _vm.selectedStatus,
                                            callback: function($$v) {
                                              _vm.selectedStatus = $$v
                                            },
                                            expression: "selectedStatus"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "dataTable",
                                fn: function() {
                                  return [
                                    _c("v-data-table", {
                                      attrs: {
                                        "item-key": "_key",
                                        expand: "",
                                        headers: _vm.headers,
                                        items: _vm.forecasts,
                                        "hide-actions": ""
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "expand",
                                            fn: function(props) {
                                              return [
                                                _c("ForecastTableExpand", {
                                                  attrs: { item: props.item }
                                                })
                                              ]
                                            }
                                          },
                                          {
                                            key: "headerCell",
                                            fn: function(props) {
                                              return [
                                                props.header.text === "quantity"
                                                  ? [
                                                      _c("v-flex", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("forecast")
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("v-flex", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "inboundQuantity"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  : props.header.text === "time"
                                                  ? [
                                                      _c("v-flex", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("createTime")
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("v-flex", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "lastModifiedTime"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  : [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.header.text
                                                        )
                                                      )
                                                    ]
                                              ]
                                            }
                                          },
                                          {
                                            key: "items",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "tr",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        props.expanded = !props.expanded
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-center"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.index + 1
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.item._key
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            style: props.item
                                                              .isDisabledOrg
                                                              ? "background-color: yellow"
                                                              : ""
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.isTenant
                                                                    ? "" +
                                                                        _vm.getWarehouseName(
                                                                          props
                                                                            .item
                                                                            .warehouseKey
                                                                        )
                                                                    : "" +
                                                                        _vm.getOrganizationName(
                                                                          props
                                                                            .item
                                                                            .organizationKey,
                                                                          props.item
                                                                        )
                                                                ) +
                                                                "\n                    "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("div", [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.getWarehouseSiteName(
                                                                  props.item
                                                                    .warehouseKey,
                                                                  props.item
                                                                    .warehouseSite
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.calculateTotalQty(
                                                                props.item
                                                                  .pkgItems
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.calculateSkuOfNum(
                                                                props.item
                                                                  .pkgItems
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.calculateBoxQty(
                                                                props.item
                                                                  .pkgItems
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                props.item
                                                                  .status ===
                                                                  "ready"
                                                                  ? "readyLower"
                                                                  : props.item
                                                                      .status
                                                              )
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              props.item
                                                                .shipType ||
                                                                "N/A"
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.toDateYYYYMMDD(
                                                              props.item
                                                                .createTime
                                                            )
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.toDateYYYYMMDD(
                                                              props.item
                                                                .lastModifiedTime
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticStyle: {
                                                          "white-space":
                                                            "pre-line",
                                                          "word-break":
                                                            "break-word",
                                                          "max-width": "300px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              props.item.note
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: _vm.forecasts,
                            callback: function($$v) {
                              _vm.forecasts = $$v
                            },
                            expression: "forecasts"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.tab === 2 && index === 2
                  ? _c(
                      "div",
                      [
                        _c("PaginationController", {
                          attrs: {
                            getDataActionName: "getBeforeShipmentForecasts",
                            haveStartDate: "",
                            haveSearchBox: "",
                            keepKeywordCase: "",
                            select: _vm.selectedValue,
                            startDateLabel: _vm.$t("processStartDate"),
                            searchBoxLabel:
                              _vm.$t("tracking") +
                              " / " +
                              _vm.$t("upc") +
                              " / sku",
                            historyLimit: _vm.historyLimit
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "beforeSearchBox",
                                fn: function() {
                                  return [
                                    _vm.isTenant
                                      ? _c(
                                          "v-flex",
                                          { attrs: { md4: "" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                items: _vm.sitesSelections,
                                                label: _vm.$t("selectSite"),
                                                "item-text": "siteName",
                                                "item-value": "key"
                                              },
                                              model: {
                                                value: _vm.selectedValue,
                                                callback: function($$v) {
                                                  _vm.selectedValue = $$v
                                                },
                                                expression: "selectedValue"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "beforeMenu",
                                fn: function() {
                                  return [
                                    _vm.isTenant
                                      ? _c(
                                          "v-layout",
                                          { attrs: { row: "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              { staticClass: "headline" },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      disabled: !_vm
                                                        .selectedPackages
                                                        .length,
                                                      color: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.showCreateShipmentDialog()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      { attrs: { dark: "" } },
                                                      [_vm._v("add")]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "completeShipment"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { staticClass: "headline" },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      disabled: !_vm
                                                        .selectedPackages
                                                        .length,
                                                      color: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.showCreateShipmentDialog(
                                                          true
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      { attrs: { dark: "" } },
                                                      [_vm._v("add")]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "splitShipment"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "dataTable",
                                fn: function() {
                                  return [
                                    _c("v-data-table", {
                                      attrs: {
                                        "select-all": _vm.isTenant && "blue",
                                        pagination: _vm.pagination,
                                        "item-key": "tracking",
                                        "rows-per-page-items": _vm.rowPerPage,
                                        headers: _vm.shipmentHeaders,
                                        items: _vm.beforeShipmentPackages
                                      },
                                      on: {
                                        "update:pagination": function($event) {
                                          _vm.pagination = $event
                                        }
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "items",
                                            fn: function(props) {
                                              return [
                                                _vm.isTenant
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "checkbox-align-center"
                                                      },
                                                      [
                                                        _c(
                                                          "v-layout",
                                                          [
                                                            _c("v-checkbox", {
                                                              attrs: {
                                                                value:
                                                                  props.selected,
                                                                primary: "",
                                                                "hide-details":
                                                                  ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return function() {
                                                                    props.selected = !props.selected
                                                                  }.apply(
                                                                    null,
                                                                    arguments
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(props.index + 1)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.item
                                                          .forecastDocKey
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        style: props.item
                                                          .isDisabledOrg
                                                          ? "background-color: yellow"
                                                          : ""
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.isTenant
                                                                ? "" +
                                                                    _vm.getWarehouseName(
                                                                      props.item
                                                                        .warehouseKey
                                                                    )
                                                                : "" +
                                                                    _vm.getOrganizationName(
                                                                      props.item
                                                                        .organizationKey,
                                                                      props.item
                                                                    )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.getWarehouseSiteName(
                                                              props.item
                                                                .warehouseKey,
                                                              props.item
                                                                .warehouseSite
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          props.item.tracking
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          props.item
                                                            .isStandardSmallBox
                                                            ? _vm.$t(
                                                                "standardSmall"
                                                              )
                                                            : (props.item
                                                                .length || 0) +
                                                                "/" +
                                                                (props.item
                                                                  .width || 0) +
                                                                "/" +
                                                                (props.item
                                                                  .height ||
                                                                  0) +
                                                                " " +
                                                                _vm.$t("inch")
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  _vm._l(
                                                    props.item.upcs,
                                                    function(pkg, index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: String(
                                                            pkg.upc + index
                                                          )
                                                        },
                                                        [
                                                          _c(
                                                            "v-layout",
                                                            [
                                                              _c("v-flex", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    pkg.upc
                                                                  )
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  staticClass:
                                                                    "text-xs-right",
                                                                  attrs: {
                                                                    "pl-4": ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      pkg.inboundQty ||
                                                                        0
                                                                    ) +
                                                                      " / " +
                                                                      _vm._s(
                                                                        pkg.inboundQty -
                                                                          (pkg.outboundQty ||
                                                                            0)
                                                                      )
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            props.item
                                                              .packageStatus ===
                                                              "ready"
                                                              ? "readyLower"
                                                              : props.item
                                                                  .packageStatus
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.toDateYYYYMMDD(
                                                          props.item
                                                            .warehousingTime
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center"
                                                  },
                                                  [
                                                    _c(
                                                      "v-tooltip",
                                                      {
                                                        attrs: { top: "" },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function(
                                                                tooltip
                                                              ) {
                                                                return [
                                                                  _c(
                                                                    "div",
                                                                    _vm._g(
                                                                      {},
                                                                      tooltip.on
                                                                    ),
                                                                    [
                                                                      _c(
                                                                        "v-btn",
                                                                        {
                                                                          attrs: {
                                                                            loading:
                                                                              _vm.shipmentLoading &&
                                                                              props
                                                                                .item
                                                                                .isLoading,
                                                                            flat:
                                                                              "",
                                                                            icon:
                                                                              "",
                                                                            color:
                                                                              "primary"
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              $event.stopPropagation()
                                                                              return _vm.removeAllOutbound(
                                                                                props.item
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            [
                                                                              _vm._v(
                                                                                "archive"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "removeShippedPkg"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: _vm.selectedPackages,
                                        callback: function($$v) {
                                          _vm.selectedPackages = $$v
                                        },
                                        expression: "selectedPackages"
                                      }
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: _vm.beforeShipments,
                            callback: function($$v) {
                              _vm.beforeShipments = $$v
                            },
                            expression: "beforeShipments"
                          }
                        }),
                        _vm._v(" "),
                        _vm.isShowShipmentDialog
                          ? _c("ForecastAddShipment", {
                              attrs: {
                                selectedPackages: _vm.selectedPackages,
                                isSplitShipment: _vm.isSplitShipment
                              },
                              on: {
                                updateBeforeShipments:
                                  _vm.updateBeforeShipments,
                                closeCreateShipments: _vm.closeCreateShipments
                              },
                              model: {
                                value: _vm.isShowShipmentDialog,
                                callback: function($$v) {
                                  _vm.isShowShipmentDialog = $$v
                                },
                                expression: "isShowShipmentDialog"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.tab === 3 && index === 3
                  ? _c(
                      "div",
                      [
                        _c(
                          "v-flex",
                          { attrs: { md2: "", right: "" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                "append-icon": "filter_list",
                                label: _vm.$t("search"),
                                "single-line": "",
                                clearable: "",
                                "hide-details": ""
                              },
                              model: {
                                value: _vm.search,
                                callback: function($$v) {
                                  _vm.search =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "search"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-data-table", {
                          attrs: {
                            headers: _vm.pendingShipmentHeaders,
                            search: _vm.search,
                            items: _vm.shipments,
                            pagination: _vm.pendingShipmentPagination,
                            "rows-per-page-items": _vm.rowPerPage
                          },
                          on: {
                            "update:pagination": function($event) {
                              _vm.pendingShipmentPagination = $event
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [_vm._v(_vm._s(props.index + 1))]
                                    ),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-xs-left" }, [
                                      _vm._v(_vm._s(props.item._key))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-xs-left" }, [
                                      _c(
                                        "div",
                                        {
                                          style: props.item.isDisabledOrg
                                            ? "background-color: yellow"
                                            : ""
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.isTenant
                                                  ? "" +
                                                      _vm.getWarehouseName(
                                                        props.item.warehouseKey
                                                      )
                                                  : "" +
                                                      _vm.getOrganizationName(
                                                        props.item.tenantKey,
                                                        props.item
                                                      )
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.getWarehouseSiteName(
                                                props.item.warehouseKey,
                                                props.item.products[0]
                                                  .warehouseSite
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-xs-left" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.trackingNum) +
                                          "\n              "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-left" },
                                      _vm._l(props.item.products, function(
                                        pkg,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          { key: String(pkg.upc + index) },
                                          [
                                            _c(
                                              "v-layout",
                                              [
                                                _c("v-flex", [
                                                  _vm._v(_vm._s(pkg.upc))
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    staticClass:
                                                      "text-xs-right",
                                                    attrs: { "pl-4": "" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(pkg.toShip || 0)
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-xs-left" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              props.item.status === "ready"
                                                ? "readyLower"
                                                : props.item.status
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.toDateYYYYMMDD(
                                              props.item.createTime
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    !_vm.isWarehouse
                                      ? _c(
                                          "td",
                                          [
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: { top: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(tooltip) {
                                                        return [
                                                          _c(
                                                            "div",
                                                            _vm._g(
                                                              {},
                                                              tooltip.on
                                                            ),
                                                            [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    loading:
                                                                      _vm.shipmentLoading &&
                                                                      props.item
                                                                        .isLoading,
                                                                    flat: "",
                                                                    color:
                                                                      "primary"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.cancelShipment(
                                                                        props.item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "delete"
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(_vm.$t("cancel")) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.tab === 4 && index === 4
                  ? _c(
                      "div",
                      [
                        _c("PaginationController", {
                          attrs: {
                            getDataActionName: "getShippedForecastShipments",
                            haveStartDate: "",
                            haveSearchBox: "",
                            keepKeywordCase: "",
                            isUsingModelInAction: "",
                            select: _vm.selectedStatus,
                            startDateLabel: _vm.$t("processStartDate"),
                            isRefreshSelect: false,
                            searchBoxLabel:
                              _vm.$t("tracking") +
                              " / " +
                              _vm.$t("upc") +
                              " / sku",
                            historyLimit: _vm.historyLimit
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "dataTable",
                                fn: function() {
                                  return [
                                    _c("v-data-table", {
                                      attrs: {
                                        pagination: _vm.pagination,
                                        "item-key": "_key",
                                        "rows-per-page-items": _vm.rowPerPage,
                                        headers: _vm.shippedShipmentHeaders,
                                        items: _vm.shippedShipments
                                      },
                                      on: {
                                        "update:pagination": function($event) {
                                          _vm.pagination = $event
                                        }
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "items",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(props.index + 1)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(props.item._key)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        style: props.item
                                                          .isDisabledOrg
                                                          ? "background-color: yellow"
                                                          : ""
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.isTenant
                                                                ? "" +
                                                                    _vm.getWarehouseName(
                                                                      props.item
                                                                        .warehouseKey
                                                                    )
                                                                : "" +
                                                                    _vm.getOrganizationName(
                                                                      props.item
                                                                        .tenantKey,
                                                                      props.item
                                                                    )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.getWarehouseSiteName(
                                                              props.item
                                                                .warehouseKey,
                                                              props.item
                                                                .products[0]
                                                                .warehouseSite
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          props.item.trackingNum
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  _vm._l(
                                                    props.item.products,
                                                    function(pkg, index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: String(
                                                            pkg.upc + index
                                                          )
                                                        },
                                                        [
                                                          _c(
                                                            "v-layout",
                                                            [
                                                              _c("v-flex", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    pkg.tracking
                                                                  )
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  staticClass:
                                                                    "right text-xs-right",
                                                                  attrs: {
                                                                    "pl-4": ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      pkg.toShip ||
                                                                        0
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticStyle: {
                                                      "white-space": "pre-line",
                                                      "word-break":
                                                        "break-word",
                                                      "max-width": "300px"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          props.item.note
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  [
                                                    _c("div", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.toDateYYYYMMDD(
                                                            props.item
                                                              .createTime
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: _vm.shippedShipments,
                            callback: function($$v) {
                              _vm.shippedShipments = $$v
                            },
                            expression: "shippedShipments"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c433636a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c433636a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForecastPackage.vue
// module id = null
// module chunks = 